import { Pipe, PipeTransform } from '@angular/core';
import { padStart } from 'lodash';
import { DateTime } from 'luxon';
import { toDateTime } from './common-conversion';

@Pipe({
    name: 'diffFromNow',
    standalone: false
})
export class DateDiffFromNowPipe implements PipeTransform {
  transform(value: string | Date | DateTime | null | undefined): string {
    const date = value ? toDateTime(value) : null;

    if (date === null) {
      return '0:00';
    }

    let { hours = 0, minutes = 0 } = date.diffNow(['hours', 'minutes']).toObject();

    // If hours are negative or minutes are negative, the pickup time has passed - display "Offen" (Open)
    if (hours < 0 || minutes < 0) {
      return $localize`:@@pickupTimeOpen:Offen`;
    }

    // Remove decimals from the minutes
    minutes = Math.abs(Math.ceil(minutes || 0));
    // Minutes should not be equal to 60
    // otherwise it should be 1 hour
    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }

    const format = (value: number | undefined) => padStart(value ? value.toString() : '0', 2, '0');

    return `${format(hours)}:${format(minutes)}`;
  }
}
